import React from 'react';
import { Card } from 'react-bootstrap';

const HomeReviews = (props) => {
    const {name, post, image,ratings} = props.review;
    return (
        <div className='mx-4'>
            <Card style={{ width: '18rem' }}>
                <Card.Img variant="top" src={image} />
                    <Card.Body>
                        <Card.Title>{name}</Card.Title>
                        <Card.Text>{post}</Card.Text>
                        <Card.Text>Ratnigs: {ratings}</Card.Text>
                 </Card.Body>
            </Card>
        </div>
    );
};

export default HomeReviews;